import React, { useState, useEffect } from "react";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { eventosDeSesion as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoEventosDeSesion as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { eventosDeSesionGet } from '../../services/hooli-services/EventosDeSesion/EventosDeSesionGet';
// recoil
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function EventosDeSesion() {
    const [eventosDeSesion, setEventosDeSesion] = useState([]);
    const [rows, setRows] = useState([]);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const [{ status }, setRow] = useRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const setFormInfo = useSetRecoilState(formData);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, eventosDeSesionGet, setEventosDeSesion);
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        eventosDeSesion.map((item) => {
            const {
                eventoSesionId,
                eventoSesionNombre,
                eventoSesionCod,
                eventoSesionVersion,
            } = item

            const evento = {
                id: eventoSesionId,
                version: eventoSesionVersion,
                [titles[0]]: eventoSesionNombre,
                [titles[1]]: eventoSesionCod,
            }

            setRows(rows => [...rows, evento])
            return item
        });
    }, [eventosDeSesion]);

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="evento" handleClick={handleClick} updateList={updateList} />
            <div className="row-grid" >
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main >
    )
};